import React from 'react';
import { Box, VStack, Text, Badge } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

const EmailSetupStepCard = ({
	step,
	shortLabel,
	isComplete,
	isActive,
	isWaiting,
	waitingLabel = 'Pending approval',
	isLocked,
	onClick,
}) => {
	const borderColor = isComplete
		? 'green.400'
		: isWaiting
			? 'blue.300'
			: isActive
				? 'orange.400'
				: 'gray.200';
	const bg = isComplete
		? 'green.50'
		: isWaiting
			? 'blue.50'
			: isActive
				? 'orange.50'
				: 'gray.50';

	return (
		<Box
			flex='1'
			minW={{ base: '140px', md: '0' }}
			border='1px solid'
			borderColor={borderColor}
			borderRadius='lg'
			p={3}
			bg={bg}
			cursor={onClick ? 'pointer' : 'default'}
			opacity={isLocked ? 0.55 : 1}
			onClick={onClick}
			transition='all 0.2s'
			_hover={onClick ? { boxShadow: 'md' } : {}}>
			<VStack spacing={2} align='center' textAlign='center'>
				<Box
					w={8}
					h={8}
					borderRadius='full'
					bg={
						isComplete
							? 'green.400'
							: isWaiting
								? 'blue.400'
								: isActive
									? 'orange.400'
									: 'gray.300'
					}
					display='flex'
					alignItems='center'
					justifyContent='center'
					flexShrink={0}>
					{isComplete ? (
						<CheckCircleIcon color='white' boxSize={4} />
					) : (
						<Text color='white' fontWeight='bold' fontSize='sm'>
							{step}
						</Text>
					)}
				</Box>
				<Text
					fontSize='xs'
					fontWeight='600'
					color={
						isComplete
							? 'green.700'
							: isWaiting
								? 'blue.700'
								: isActive
									? 'orange.700'
									: 'gray.600'
					}
					lineHeight='short'>
					{shortLabel}
				</Text>
				{isComplete && (
					<Badge colorScheme='green' fontSize='9px' borderRadius='full'>
						Completed
					</Badge>
				)}
				{isWaiting && (
					<Badge colorScheme='blue' fontSize='9px' borderRadius='full'>
						{waitingLabel}
					</Badge>
				)}
				{isActive && !isWaiting && (
					<Badge colorScheme='orange' fontSize='9px' borderRadius='full'>
						Next step
					</Badge>
				)}
			</VStack>
		</Box>
	);
};

export default EmailSetupStepCard;
